export const MAIL_SERVICE_URL = 'https://elfsightmail.com';
export const MAIL_SERVICE_URL_STAGE = 'https://stage.elfsightmail.com';

export const DATA_SERVICE_URL = 'https://data.elfsight.com';
export const DATA_SERVICE_URL_STAGE = 'https://data.elfhome.ru';

export const STORAGE_AUTH_URL = 'https://storage.elfsight.com/auth';
export const STORAGE_AUTH_URL_STAGE = 'https://storage.elfhome.ru/auth';
